module.exports = __webpack_public_path__ + "static/img/cultureItem3.5aacaf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newLasur/cultureItem3.png
// module id = OFLm
// module chunks = 0